import { LocalShoppingItemsData } from '../../providers/local-shopping-items-data';
import { ShoppingItemsDataGateway } from '../../providers/shopping-items-data-gateway';
import { Utils } from '../../../../providers/utils';
import { Component, ChangeDetectorRef } from '@angular/core';
import { NavController, Events, App } from 'ionic-angular';
import { ShoppingListCommon } from './shopping-list.common';
import { PageBase } from '../../../../core/page-base';
import { UserData } from '../../../../providers/user-data';
import { AppSettings } from '../../../../config/app-settings';
import { PageRef } from '../../../../core/core.module';
import { ShoppingListData } from '../../providers/shopping-list-data';
import { Helpers } from '../../../../providers/helpers';

@Component({
	selector: 'page-shopping-list',
	templateUrl: 'shopping-list.html'
})

export class ShoppingListPage extends PageBase {

	public shopItems = [];
	public switchs = {};
	public userId = '';
	shoppingItemsData: any;
	constructor(
		public events: Events,
		public app: App,
		public cd: ChangeDetectorRef,
		public common: ShoppingListCommon,
		public shoppingListData: ShoppingListData,
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public pageRef: PageRef,
		public shoppingItemsDataGateway: ShoppingItemsDataGateway,
		public localShoppingItemsData: LocalShoppingItemsData,
		public helpers: Helpers

	) {
		super(settings, events, nav, userData);
	}

	ionViewDidEnter() {
		this.app.setTitle('Shopping List');
	}

	ngAfterViewInit() {
		this.common.commonMethod();
		this.userId = this.currentUser ? this.currentUser.uid : '';
		this.shoppingItemsData = this.shoppingItemsDataGateway.getService(this.userId);
		this.loadData();
	}

	//UI Events
	toggleSwitch(cat) {
		this.switchs[cat] = !this.switchs[cat];

	};
	public selectGotItem(item) {
		item.isGot = !item.isGot;
		this.shoppingItemsData.updateIsGotItem(this.userId, item, item.isGot);
	}
	removeListItemClick(item){
		var self = this;

		self.helpers.confirm(
			'',
			'Are you sure remove this item?',
			function(){
				self.removeListItem(item);
			}
		);
	}

	//Functions
	removeListItem(item){
		var self = this;
		self.shoppingItemsData.remove(self.userId, item.$key).then(result =>{
			if(result){
				self.loadData();
				self.helpers.toast("Removed successfully!");
			}
		})
	}
	loadData() {
		var self = this;
		self.helpers.showLoading();
		
		self.shoppingItemsData.get(this.userId).subscribe(shopitems => {
			shopitems = Utils.toAngularFireArray(shopitems).reverse();
			var shopItemData = [];
			_.forEach(shopitems, function (item) {
				if (item.$key != 'timestampCreated') {
					var shopItem = item;
					// shopItem.itemId = item.$key;
					shopItemData.push(shopItem);
				}
			});
			shopItemData = _.sortBy(shopItemData, function (item) {
				return item.categoryName;
			});
			var catQuanity = {};
			_.groupBy(shopItemData, function (item) {
				var catName = item.categoryName;
				catQuanity[catName] = catQuanity[catName] ? catQuanity[catName] + item.quantity : item.quantity;
				return catName;
			});
			var catTemp = '';
			_.forEach(shopItemData, function (item) {
				item.catQuantity = catQuanity[item.categoryName];

				if (catTemp != '' && item.categoryName == catTemp) {
					item.categoryName = '';//don't display catName while render shopping list ;
				}
				else {
					catTemp = item.categoryName;
				}

			});
			self.shopItems = shopItemData;
						
			self.helpers.hideLoading();
		});
	}	
}


// WEBPACK FOOTER //
// ./src/modules/account/pages/shopping-list/shopping-list.ts